<template>
    <div class="settings-page">
        <div class="section-block">
            <h3 class="section-title">壁纸设置</h3>
            <div class="wallpaper-preview" :style="wallpaperStyle">
                <div class="upload-overlay">
                    <a-upload
                        :auto-upload="false"
                        :show-file-list="false"
                        @change="handleFileChange"
                        accept="image/*"
                    >
                        <template #upload-button>
                            <a-button type="primary" shape="round">
                                <template #icon><icon-upload /></template>
                                更换壁纸
                            </a-button>
                        </template>
                    </a-upload>
                    <div v-if="isUploading" class="uploading-state">
                        <a-spin />
                    </div>
                </div>
            </div>
        </div>

        <div class="section-block">
            <h3 class="section-title">卡片样式</h3>
            <CardStyleSettings/>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref, computed } from 'vue';
import { useStore } from 'vuex';
import { Message } from '@arco-design/web-vue';
import { IconUpload } from '@arco-design/web-vue/es/icon';
import CardStyleSettings from "@/components/layouts/CardStyleSettings.vue";

export default defineComponent({
    name: "Settings",
    components: { CardStyleSettings, IconUpload },
    setup() {
        const store = useStore();
        const isUploading = ref(false);

        const backgroundUrl = computed(() => store.getters['wallpapers/backgroundUrl']);

        const wallpaperStyle = computed(() => ({
            backgroundImage: `url(${backgroundUrl.value})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
        }));

        const uploadWallpaper = (file) => store.dispatch('wallpapers/uploadWallpaper', file);

        const handleFileChange = async (fileList) => {
            const file = fileList[fileList.length - 1];
            if (!file) return;

            const rawFile = file.file;
            const isImage = rawFile.type.startsWith("image/");
            const isLt5M = rawFile.size / 1024 / 1024 < 5;

            if (!isImage) return Message.error("只能上传图片文件!");
            if (!isLt5M) return Message.error("图片大小不能超过 5MB!");

            isUploading.value = true;
            try {
                await uploadWallpaper(rawFile);
                Message.success("壁纸更新成功!");
            } catch (error) {
                Message.error(`上传失败: ${error.message}`);
            } finally {
                isUploading.value = false;
            }
        };

        return {
            isUploading,
            wallpaperStyle,
            handleFileChange,
        };
    }
});
</script>

<style scoped>
.settings-page {
    padding-bottom: 20px;
}

.section-block {
    margin-bottom: 30px;
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-main);
    margin-bottom: 12px;
}

.wallpaper-preview {
    width: 100%;
    height: 200px;
    border-radius: 12px;
    position: relative;
    overflow: hidden;
    background-color: #f0f0f0;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.upload-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity 0.3s;
}

.wallpaper-preview:hover .upload-overlay {
    opacity: 1;
}

.uploading-state {
    margin-left: 10px;
}
</style>
